/* eslint-disable react/jsx-props-no-spreading */
import styled from "@emotion/styled";
import {
  Heading,
  type HeadingProps,
  Spacer,
  type SpacerProps,
  MediaQueries,
  Spacings,
  Text,
  HeadingVariantSizes,
} from "@polestar/component-warehouse-react";
import React, { type FC } from "react";

const StyledHeadingLevelThree = styled(Heading)`
  ${MediaQueries.tablet} {
    margin-left: ${Spacings.medium};
    & ~ p {
      margin-left: ${Spacings.medium};
    }
    & ~ ul {
      margin-left: ${Spacings.medium};
    }
    & ~ div[data-typename="LegalDocumentBody"] {
      margin-left: ${Spacings.medium};
    }
  }
`;

/**
 * Used for keeping heading styles consistent between the simple content (HTML string) documents
 * and structured text content (DAST) documents.
 */
const ContentHeading: FC<HeadingProps & Pick<SpacerProps, "spacing">> = ({
  children,
  spacing,
  ...props
}) => {
  if (props.level === 1 || props.level === 2) {
    return (
      <>
        <Heading {...props} level={2} variant={HeadingVariantSizes.medium}>
          {children}
        </Heading>
        {spacing && <Spacer spacing={spacing} />}
      </>
    );
  }

  if (props.level === 3) {
    return (
      <>
        <StyledHeadingLevelThree variant={HeadingVariantSizes.small} level={3}>
          {children}
        </StyledHeadingLevelThree>
        {spacing && <Spacer spacing={Spacings.large} />}
      </>
    );
  }

  return (
    <>
      <Text as={props.level ? `h${props.level}` : undefined} {...props}>
        {children}
      </Text>
      {spacing && <Spacer spacing={spacing} />}
    </>
  );
};

export default ContentHeading;
